const CLIENT_ENV = 'production';
export default CLIENT_ENV;
